export default __webpack_public_path__ + "static/media/not-found.51f2dc19.svg";